import ConfirmationService from 'primevue/confirmationservice'
import type { App } from 'vue'

export function registerPrimeVueConfirmation(app: App) {
  app.use(ConfirmationService)
}
